/**
 * SMB Component - available services
 * @copyright 2018 AVAST Software s.r.o.
 * @author Alex Ratman
 * @since 2018-08-22
 *
 * DESCRIPTION:
 * Functionality for 'available services'
 *
 */

"use strict";

$(document).ready(function () {
  var btns = $('.available-services .button_arrow');
  var features = $('.available-services__box-services');

  btns.on('click', function(e) {
    e.preventDefault();

    btns.toggleClass('active');
    features.toggleClass('active');
  });
});